<template>
  <div>Create Email Template</div>
</template>
<script>
export default {
  name: 'create_email_template',
  components: {},
  data() {
    return {}
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  watch: {},
  methods: {},
}
</script>
<style scoped lang="scss"></style>
<style lang="scss"></style>
